import React from 'react';
import { Empty } from 'antd';
import { BidirectionalBar } from '@ant-design/plots';

const ConnectedUserStatsChart = ({ data }) => {
  const chartData = data?.reduce((acc, item) => {
    const country = item.source || item.destination;
    const existing = acc.find(d => d.country === country);
    if (!existing) {
      acc.push({
        country,
        source: item.source ? item.total_users : 0,
        destination: item.destination ? item.total_users : 0,
      });
    } else {
      if (item.source) existing.source = item.total_users;
      if (item.destination) existing.destination = item.total_users;
    }
    return acc;
  }, []);

  return chartData?.length ? (
    <BidirectionalBar
      data={chartData}
      xField="country"
      yField={["source", "destination"]}
      xAxis={{ position: "bottom" }}
      height={200}
      tooltip={{ shared: true, showMarkers: false }}
      interactions={[{ type: "active-region" }]}
    />
  ) : (
    <Empty />
  );
};

export default ConnectedUserStatsChart;
